import * as ReactDOM from 'react-dom'
import { RouterProvider, RouterProviderProps } from 'react-router'

export function RouterProviderDom(props: RouterProviderProps) {
  return <RouterProvider flushSync={ReactDOM.flushSync as RouterProviderProps['flushSync']} {...props} />
}
